<template>
    <!-- Outros Atendimentos -->
    <div v-if="exibicao_outros && exibicao_outros.length" class="mb-3">

        <div class="card carde mb-2 w3-animate-opacity" v-for="(outro, index) in exibicao_outros" :key="index">

            <div class="card-body p-1 pr-2 alert-warning">
                <div class="row">
                    <!-- Ação -->
                    <div class="col col-12 col-md-2 d-flex flex-column justify-content-center py-1" id="botao-acao" >
                        <div class="btn-group mx-2 my-2 my-md-0" role="group">
                            <template v-for="(acao, iax) in outro.acoes">
                                <button type="button" class="btn btn-sm" :class="'btn-' + acao.color" :key="iax"
                                    @click="executar_acao_outro(outro, acao)" 
                                    :disabled="!acao.id_proxima_etapa || outro.loading">
                                    <i :class="acao.titulo" aria-hidden="true" v-if="acao.icon"></i>
                                    <span v-else>{{ acao.titulo }}</span>
                                </button>
                            </template>
                        </div>

                        <div class="small text-muted text-center" v-if="
                            outro 
                            && agora
                            && outro.dt_inicio.substr(0,10) == $util.hoje() 
                            && outro.acoes.find(acao => acao.titulo == 'Chamar')">

                            <span v-if="te_max && te_max < duracao(outro.dt_inicio, false)" class="badge badge-danger">
                                Esperando {{ duracao(outro.dt_inicio) }}...
                            </span>

                            <span v-else class="small text-muted">
                                Esperando {{ duracao(outro.dt_inicio) }}...
                            </span>

                        </div>
                    </div>

                    <!-- Hora da Marcação -->
                    <div class="col col-12 col-md-2">
                        <i class="fas fa-clock mr-1"></i>
                        {{ outro.dt_inicio.substr(11,5) }}
                        <a class="text-danger ml-2" href="#" @click.prevent="remover_senha(outro)" title="Remover">
                            <i class="fa fa-times" aria-hidden="true"></i>
                        </a>

                        <div v-if="outro.id_atendimento" title="Atendimento">
                            #{{ outro.id_atendimento }}
                        </div>
                    </div>

                    <!-- Identificação do Paciente -->
                    <div class="col col-12 col-md-4">
                        <template v-if="outro.id_paciente">
                            <celula-dados-paciente :hor="{ marcacao: outro }" />
                        </template>
                        <template v-else>
                            <a href="#" @click.prevent="$emit('search', outro.st_nome)" v-if="link_search" class="card-link">
                                {{ outro.st_nome }}    
                            </a>
                            <span v-else>
                                {{ outro.st_nome }}
                            </span>
                        </template>
                        <div class="small text-muted" v-if="outro.usuario && outro.usuario.pessoa">
                            Registrado por: {{ outro.usuario.pessoa.st_nome }}
                        </div>
                    </div>

                    <!-- Observação -->
                    <div class="col col-12 col-md-4 d-flex justify-content-between align-items-center">
                        <div>
                            <a href="#" @click.prevent="$emit('search', outro.st_observacoes)" v-if="link_search" class="card-link" style="white-space: pre-wrap;">{{ outro.st_observacoes }}</a>
                            <span style="white-space: pre-wrap;" v-else>{{ outro.st_observacoes }}</span>
                            <div class="small text-muted" v-if="outro.paciente && outro.paciente.st_nome != outro.st_nome">{{ outro.st_nome }}</div>
                            
                        </div>
                        <div v-if="outro">
                            <slot name="acao-paciente" v-bind:outro="outro"></slot>
                        </div>
                    </div>

                </div>
            </div>
        </div>

    </div>
</template>

<script>
import $ from 'jquery';
import _ from 'lodash';
import * as moment from 'moment';
import CelulaDadosPaciente from '../shared/table/CelulaDadosPaciente.vue';

export default {
    data() {
        return { 
            reident_user: false, 
            identificando: null, 
        }
    },

    props: ['outros', 'na_recepcao', 'na_coleta', 'search', 'link_search', 'agora', 'te_max'],
    
    components: { 
        CelulaDadosPaciente,
    },

    computed: { 
        exibicao_outros: function () { 
            if ( !this.outros ) 
                return;

            if ( !this.outros.length ) 
                return;

            let reg = this.$util.getregex(this.search ? this.search : '');

            return this.outros.filter(item => item.id_etapa_atendimento != 7 && ( !this.search || reg.test(JSON.stringify(item)) ) );
        },
    },
    
    methods: { 
        remover_senha (outro) { 
            let nome = outro.paciente ? outro.paciente.st_nome : outro.st_nome;

            if ( !confirm('Confirma remover o registro de ' + nome + '?') ) { 
                return;
            }

            this.$util.toggle(this, { 
                service: 'atendimento_outros',
                dados: { 
                    id_atendimento_outro: outro.id_atendimento_outro
                },
                callback: () => { 
                    this.$emit('refresh');
                },
                toast: true,  
            });
        },

        identificar_usuario_coleta(info) { 
            $('.modal').modal('hide');

            this.executar_acao_outro(this.identificando.outro, this.identificando.acao, info);
        },

        executar_acao_outro(outro, acao, ident = null) { 
            if ( !outro.id_etapa_atendimento && acao && acao.id_proxima_etapa == 5 && this.reident_user && this.$parent.$refs.amostras && !ident ) { 
                this.identificando = { 
                    outro: outro, 
                    acao: acao,
                };

                this.$parent.$refs.amostras.$refs.ident_user.abrir(this.identificar_usuario_coleta);
                return;
            }

            outro.loading = true;

            let dados = _.cloneDeep(outro);

            dados.id_etapa_atendimento = acao.id_proxima_etapa;
            dados.consultorio = true;
            dados.local = this.$util.getCookie('local-chamada');
            dados.na_recepcao = this.na_recepcao; 
            dados.na_coleta = this.na_coleta; 

            if ( ident ) { 
                dados.login = ident.login;
                dados.senha = ident.senha;

                this.identificando = null;
            }
            
            this.$util.atualizar(this, { 
                service: 'atendimento_outros',
                dados: dados, 
                callback: () => { 
                    this.$emit('refresh');
                },
                toast: true,  
            });
        },

        duracao (data, humanize = true) { 
            return humanize
                ? moment
                    .duration(moment(data, "YYYY-MM-DD HH:mm:ss").diff(this.agora))
                    .humanize(true)
                : moment
                    .duration(moment(this.agora, "YYYY-MM-DD HH:mm:ss").diff(data))
                    .asMinutes();
        },
    },

    mounted() { 
        if ( this.na_coleta && this.$store.state.user.st_login && this.$store.state.user.st_login.slice(0,6) == 'coleta' ) { 
            this.reident_user = true;
        }
    }
}
</script>
